<template>
    <div class="relative bg-gray-100">
        <Intercom />
        <Navbar @handleSideBarMobile="() => {}" />

        <!--        <CyberMondayBanner-->
        <!--            v-if="shouldDisplayBlackFridayDeal"-->
        <!--            class="sticky z-20 top-14 md:relative md:top-0"-->
        <!--        />-->

        <PluginTrialBanner
            v-if="
                shouldDisplayActivePluginTrialBanner &&
                !globalProps.isAdmin &&
                !shouldDisplayDeletedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            :date="globalProps.user.plugin_trial_ends_at"
        />

        <TrialEndedBanner
            v-if="
                shouldDisplayPluginTrialBanner &&
                !globalProps.isAdmin &&
                !shouldDisplayDeletedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            :date="globalProps.user.plugin_trial_ends_at"
            type="plugin"
        />

        <TrialEndedBanner
            v-if="
                shouldDisplayProTrialBanner &&
                !shouldDisplayPluginTrialBanner &&
                !shouldDisplayPluginSubscriptionBanner &&
                !shouldDisplayProPersonalSubscriptionBanner &&
                !isPluginSubscribed &&
                !globalProps.isAdmin &&
                !shouldDisplayDeletedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            :date="globalProps.user.pro_trial_ends_at"
            type="pro"
        />

        <SubscriptionBanner
            v-if="
                shouldDisplayPluginSubscriptionBanner &&
                !shouldDisplayPluginTrialBanner &&
                !globalProps.isAdmin &&
                !shouldDisplayDeletedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            type="plugin"
        />

        <SubscriptionBanner
            v-if="
                shouldDisplayProPersonalSubscriptionBanner &&
                !shouldDisplayPluginSubscriptionBanner &&
                !isPluginSubscribed &&
                !globalProps.isAdmin &&
                !shouldDisplayDeletedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            type="pro-personal"
        />

        <SubscriptionBanner
            v-if="
                shouldDisplayProTeamSubscriptionBanner &&
                !globalProps.isAdmin &&
                !shouldDisplayDeletedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            type="pro-team"
        />

        <InfoBanner
            v-if="shouldDisplayDeletedBanner"
            :show="shouldDisplayDeletedBanner"
            class="sticky z-20 top-14 md:relative md:top-0"
            title="Your templates have been removed due to prolonged inactivity, and your profile is scheduled for permanent deletion in 30 days"
        >
            For more information on how to restore them, please contact our
            support team at support@topol.io.
        </InfoBanner>

        <InfoBanner
            v-if="latestPaymentRequest"
            :show="latestPaymentRequest !== null"
            class="sticky z-20 top-14 md:relative md:top-0"
            :title="
                'Your payment for ' + latestPaymentRequest.name + ' is due soon'
            "
        >
            Please complete your payment of ${{
                latestPaymentRequest.formattedTotal
            }}
            by
            {{
                format(new Date(latestPaymentRequest.due_date), 'd MMMM, yyyy')
            }}
            to avoid any service issues.

            <inertia-link
                :href="
                    route('payment-requests.show', latestPaymentRequest.uuid)
                "
                class="font-medium text-topol-blue-500 hover:text-topol-blue-600"
                >Click here to proceed.</inertia-link
            >
        </InfoBanner>

        <InfoBanner
            v-if="
                shouldDisplayTeamBucketBlockedBanner &&
                !shouldDisplayProPersonalSubscriptionBanner &&
                !shouldDisplayProTeamSubscriptionBanner &&
                !shouldDisplayApiTokensBucketsBlockedBanner
            "
            :show="
                shouldDisplayTeamBucketBlockedBanner &&
                !shouldDisplayProPersonalSubscriptionBanner &&
                !shouldDisplayProTeamSubscriptionBanner &&
                !shouldDisplayApiTokensBucketsBlockedBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            title="Your storage has been blocked. You won't be able to use images in your templates."
        >
            For more information on how to unblock it, please contact our
            support team at support@topol.io.
        </InfoBanner>

        <InfoBanner
            v-if="
                shouldDisplayApiTokensBucketsBlockedBanner &&
                !shouldDisplayPluginSubscriptionBanner
            "
            :show="
                shouldDisplayApiTokensBucketsBlockedBanner &&
                !shouldDisplayPluginSubscriptionBanner
            "
            class="sticky z-20 top-14 md:relative md:top-0"
            title="Your storage has been blocked for at least one of your API tokens."
        >
            For more information on how to unblock it, please contact our
            support team at support@topol.io.
        </InfoBanner>

        <div
            v-if="globalProps.user.isImpersonating"
            class="fixed bottom-0 left-0 flex flex-wrap items-center justify-between w-full px-10 py-2 z-500 bg-gray-900/50"
        >
            <div class="my-1 text-sm text-white">
                You are now seeing the app as: {{ globalProps.user.name }}
            </div>
            <AtomicButton size="sm" color="purple" @click="endImpersonation">
                <template #icon>
                    <EyeSlashIcon class="w-6 h-6 mr-2" />
                </template>
                Leave impersonation
            </AtomicButton>
        </div>

        <div
            class="grid min-h-[calc(100vh-56px)] grid-cols-1 md:min-h-[calc(100vh-64px)] md:grid-cols-[64px_1fr] xl:grid-cols-[256px_1fr]"
        >
            <PluginSidebar
                v-if="globalProps.user.app_type === 'plugin' && !isKiosk"
                v-click-away="onClickAway"
                :opened="sidebarOpened"
                @close="sidebarOpened = false"
                @open="sidebarOpened = true"
            />
            <Sidebar
                v-else-if="globalProps.user.app_type === 'pro' || globalProps.user.app_type === 'both' || globalProps.user.app_type === null || isKiosk"
                v-click-away="onClickAway"
                :opened="sidebarOpened"
                @close="sidebarOpened = false"
                @open="sidebarOpened = true"
            />

            <div
                class="mx-auto w-full px-5 pt-[56px] opacity-100 blur-none transition duration-300 ease-in-out sm:px-10 md:pt-0 xl:max-w-[1328px] xl:opacity-100 xl:blur-none"
                :class="{
                    'pointer-events-none md:opacity-90 md:blur-xs':
                        sidebarOpened,
                }"
            >
                <slot />
            </div>
        </div>

        <ConfirmDialog></ConfirmDialog>
        <Notifications></Notifications>

        <ShoppingCartModal />
    </div>
</template>
<script lang="ts" setup>
import Navbar from '@components/Navigation/Navbar.vue';
import Sidebar from '@components/Navigation/Sidebar.vue';
import PluginSidebar from '@components/Navigation/PluginSidebar.vue';
import { computed, onMounted, ref } from 'vue';
import ConfirmDialog from '@atomic/Dialogs/ConfirmDialog.vue';
import Notifications from '@/components/Notifications.vue';
import { usePage } from '@inertiajs/vue3';
import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import TrialEndedBanner from '../components/Navigation/components/TrialEndedBanner.vue';
import PluginTrialBanner from '../components/Navigation/components/PluginTrialBanner.vue';
import AtomicButton from '@/components/Atomic/Buttons/AtomicButton.vue';
import { router } from '@inertiajs/vue3';
import { route } from 'ziggy-js';
import { EyeSlashIcon } from '@heroicons/vue/24/outline';
import SubscriptionBanner from '@components/Navigation/components/SubscriptionBanner.vue';
import Bugsnag from '@bugsnag/js';
import ICurrentTeam from '@/types/Members/ICurrentTeam';
import { format } from 'date-fns';

const globalProps = computed(() => usePage<ITopolPageProps>().props);
const teamProps = computed(() => globalProps.value.team as ICurrentTeam);

onMounted(async () => {
    const userObject = {
        id: globalProps.value.user.id,
        email: globalProps.value.user.email,
        current_team_id: teamProps.value.id,
    };
    Bugsnag.setUser(JSON.stringify(userObject));

    await getData();
});

const {
    shouldDisplayProTrialBanner,
    shouldDisplayPluginTrialBanner,
    shouldDisplayPluginSubscriptionBanner,
    shouldDisplayProPersonalSubscriptionBanner,
    shouldDisplayProTeamSubscriptionBanner,
    shouldDisplayDeletedBanner,
    shouldDisplayApiTokensBucketsBlockedBanner,
    fetchPaymentRequestData,
    fetchBanners,
    latestPaymentRequest,
} = useBanners();

const { fetchSubscriptions, isPluginSubscribed } = useSubscriptions();

const { fetchTeams, getCurrentTeamMembersCount } = useTeamsAndMembers();

const page = computed(() => usePage<ITopolPageProps>().url);
const isKiosk = computed(() => {
    return page.value.startsWith('/kiosk');
});

const shouldDisplayTeamBucketBlockedBanner = computed(() => {
    return teamProps.value.bucket_blocked_at !== null;
});

const shouldDisplayActivePluginTrialBanner = computed(() => {
    return (
        globalProps.value.user.app_type === 'plugin' &&
        globalProps.value.user.plugin_trial_ends_at &&
        new Date(globalProps.value.user.plugin_trial_ends_at) > new Date() &&
        !shouldDisplayPluginTrialBanner.value
    );
});

const getData = async () => {
    await fetchSubscriptions();
    await fetchBanners();
    await getCurrentTeamMembersCount();
    await fetchTeams();
    await fetchPaymentRequestData();
};

const sidebarOpened = ref(false);
const onClickAway = () => {
    sidebarOpened.value = false;
};
const endImpersonation = () => {
    router.delete(
        route('kiosk.users.nonimpersonate', {
            user: globalProps.value.user.id,
        }),
        {
            onSuccess: () => {
                getData();
            },
        }
    );
};
</script>

<style></style>
